var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-table',{attrs:{"store-name":"adminacts","query-filter":_vm.queryFilter,"headers":_vm.headers,"item-actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }